import type { Template } from "@/types";

export const LA_06_H2_V4: Template[] = [
    {
        id: "la-06-h2v4-01",
        name: "LA 01 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h2_v4_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 65, y: 48, width: 256, height: 388, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 329, y: 48, width: 282, height: 190, rotation: 0, imageRotation: 0 },
            { id: "3", x: 329, y: 246, width: 282, height: 190, rotation: 0, imageRotation: 0 },
            { id: "4", x: 802, y: 48, width: 282, height: 388, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1092, y: 48, width: 135, height: 190, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1092, y: 246, width: 135, height: 190, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-02",
        name: "LA 02 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h2_v4_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 187, y: 31, width: 304, height: 420, rotation: 0, imageRotation: 0 },
            { id: "2", x: 789, y: 32, width: 334, height: 206, rotation: 0, imageRotation: 0 },
            { id: "3", x: 789, y: 246, width: 334, height: 205, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1130, y: 32, width: 109, height: 135, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1130, y: 175, width: 109, height: 134, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1130, y: 317, width: 109, height: 134, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-03",
        name: "LA 03 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h2_v4_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 186, y: 48, width: 305, height: 189, rotation: 0, imageRotation: 0 },
            { id: "2", x: 186, y: 245, width: 305, height: 189, rotation: 0, imageRotation: 0 },
            { id: "3", x: 873, y: 48, width: 137, height: 189, rotation: 0, imageRotation: 0 },
            { id: "4", x: 873, y: 245, width: 137, height: 189, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 48, width: 137, height: 189, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 245, width: 137, height: 189, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-04",
        name: "LA 04 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h2_v4_04.png",
        size: [1352, 483],
        style: {},
        slots: [       
            { id: "1", x: 132, y: 45, width: 132, height: 193, rotation: 0, imageRotation: 0 },
            { id: "2", x: 132, y: 246, width: 132, height: 192, rotation: 0, imageRotation: 0 },
            { id: "3", x: 272, y: 246, width: 132, height: 192, rotation: 0, imageRotation: 0 },
            { id: "4", x: 412, y: 246, width: 132, height: 192, rotation: 0, imageRotation: 0 },
            { id: "5", x: 272, y: 45, width: 272, height: 193, rotation: 0, imageRotation: 0 },
            { id: "6", x: 767, y: 83, width: 494, height: 318, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-05",
        name: "LA 05 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h2_v4_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 118, y: 45, width: 440, height: 251, rotation: 0, imageRotation: 0 },
            { id: "2", x: 118, y: 303, width: 105, height: 136, rotation: 0, imageRotation: 0 },
            { id: "3", x: 230, y: 303, width: 105, height: 136, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 303, width: 105, height: 136, rotation: 0, imageRotation: 0 },
            { id: "5", x: 454, y: 303, width: 104, height: 136, rotation: 0, imageRotation: 0 },
            { id: "6", x: 767, y: 83, width: 494, height: 318, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-06",
        name: "LA 06 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h2_v4_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 65, y: 66, width: 477, height: 351, rotation: 0, imageRotation: 0 },
            { id: "2", x: 681, y: 66, width: 125, height: 172, rotation: 0, imageRotation: 0 },
            { id: "3", x: 681, y: 246, width: 125, height: 171, rotation: 0, imageRotation: 0 },
            { id: "4", x: 550, y: 66, width: 124, height: 172, rotation: 0, imageRotation: 0 },
            { id: "5", x: 550, y: 246, width: 124, height: 171, rotation: 0, imageRotation: 0 },
            { id: "6", x: 814, y: 66, width: 474, height: 351, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-07",
        name: "LA 07 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h2_v4_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 65, y: 66, width: 124, height: 172, rotation: 0, imageRotation: 0 },
            { id: "2", x: 65, y: 246, width: 124, height: 171, rotation: 0, imageRotation: 0 },
            { id: "3", x: 196, y: 66, width: 477, height: 351, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 66, width: 125, height: 172, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 246, width: 125, height: 171, rotation: 0, imageRotation: 0 },
            { id: "6", x: 814, y: 66, width: 474, height: 351, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-08",
        name: "LA 08 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h2_v4_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 65, y: 66, width: 124, height: 172, rotation: 0, imageRotation: 0 },
            { id: "2", x: 65, y: 246, width: 124, height: 171, rotation: 0, imageRotation: 0 },
            { id: "3", x: 196, y: 66, width: 125, height: 172, rotation: 0, imageRotation: 0 },
            { id: "4", x: 196, y: 246, width: 125, height: 171, rotation: 0, imageRotation: 0 },
            { id: "5", x: 329, y: 66, width: 477, height: 351, rotation: 0, imageRotation: 0 },
            { id: "6", x: 814, y: 66, width: 474, height: 351, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-09",
        name: "LA 09 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h2_v4_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 47, width: 527, height: 390, rotation: 0, imageRotation: 0 },
            { id: "2", x: 535, y: 47, width: 138, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 535, y: 246, width: 138, height: 191, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 47, width: 526, height: 390, rotation: 0, imageRotation: 0 },    
            { id: "5", x: 1215, y: 47, width: 137, height: 191, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1215, y: 246, width: 137, height: 191, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-10",
        name: "LA 10 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h2_v4_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 66, width: 552, height: 353, rotation: 0, imageRotation: 0 },
            { id: "2", x: 559, y: 66, width: 114, height: 173, rotation: 0, imageRotation: 0 },   
            { id: "3", x: 559, y: 247, width: 114, height: 172, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 66, width: 113, height: 173, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 247, width: 113, height: 172, rotation: 0, imageRotation: 0 },
            { id: "6", x: 801, y: 66, width: 551, height: 353, rotation: 0, imageRotation: 0 }
        ],
    }
];